export default "__VITE_ASSET__D136UmtM__"